export function calculateRefund(booking, isHirerCancelling) {
  if (!booking) return { refundAmount: 0, feeAmount: 0, policy: 'none' }

  if (!booking.paid_at && !booking.stripe_payment_intent_id) {
    return { refundAmount: 0, feeAmount: 0, policy: 'unpaid' }
  }

  if (!isHirerCancelling) {
    return { refundAmount: booking.total_amount, feeAmount: 0, policy: 'owner-cancel' }
  }

  const now = new Date()
  const startDate = new Date(booking.start_date)
  const hoursToStart = (startDate - now) / (1000 * 60 * 60)

  if (hoursToStart >= 48) {
    return { refundAmount: booking.total_amount, feeAmount: 0, policy: '48+hr' }
  } else if (hoursToStart >= 24) {
    const hireSubtotal = (booking.total_amount || 0) - (booking.deposit_amount || 0)
    const fee = Math.round(hireSubtotal * 0.50 * 100) / 100
    return {
      refundAmount: Math.round((booking.total_amount - fee) * 100) / 100,
      feeAmount: fee,
      policy: '24-48hr'
    }
  } else {
    const hireSubtotal = (booking.total_amount || 0) - (booking.deposit_amount || 0)
    const fee = Math.round(hireSubtotal * 1.00 * 100) / 100
    return {
      refundAmount: Math.round((booking.total_amount - fee) * 100) / 100,
      feeAmount: fee,
      policy: 'under-24hr'
    }
  }
}
